import { TemplateItem } from "./template-item.model";

export interface TemplateGroup {
  id: string;
  label: string;
  description?: string;
  items: TemplateItem[];
}

export const TEMPLATE_GROUPS: TemplateGroup[] = [
  {
    id: 'core',
    label: 'Core Templates',
    description: 'Default layouts for everyday publishing.',
    items: [
      { id: 'none', label: 'None', image: 'assets/icon/image-templates/image-template-none.jpg', defaultImagePlacement: 'attention' },
      { id: 'title-only', label: 'Title only', usesTitle: true, image: 'assets/icon/image-templates/image-template-title-only.jpg', defaultImagePlacement: 'attention' },
      { id: 'title-blurb', label: 'Title + blurb', usesTitle: true, usesBlurb: true, image: 'assets/icon/image-templates/image-template-title-blurb.jpg', defaultImagePlacement: 'attention' },
      { id: 'stacked-left', label: 'Stacked left', usesTitle: true, image: 'assets/icon/image-templates/image-template-stacked-left.jpg', defaultImagePlacement: 'attention' },
      // file is named "stacked-centered" in assets; keep id 'stacked_center' for consistency with enums/types
      { id: 'stacked-center', label: 'Stacked center', usesTitle: true, image: 'assets/icon/image-templates/image-template-stacked-centered.jpg', defaultImagePlacement: 'attention' }
    ]
  },
  {
    id: 'news-cards',
    label: 'News Templates',
    description: 'High-impact newsroom treatments for headlines and briefs.',
    items: [
      { id: 'news-breaking-slate', label: 'Breaking slate', usesTitle: true, usesBlurb: true, image: 'assets/icon/image-templates/image-template-news-breaking-slate.jpg', defaultImagePlacement: 'attention', tags: ['pro', 'news'] },
      { id: 'news-focus-split', label: 'Focus split', usesTitle: true, usesBlurb: true, image: 'assets/icon/image-templates/image-template-news-focus-split.jpg', defaultImagePlacement: 'center', tags: ['pro', 'news'] },
      { id: 'news-banner-top', label: 'Banner top', usesTitle: true, usesBlurb: true, image: 'assets/icon/image-templates/image-template-news-banner-top.jpg', defaultImagePlacement: 'attention', tags: ['pro', 'news'] }
    ]
  },
  {
    id: 'quote-cards',
    label: 'Quote Templates',
    description: 'Designed for pull quotes, thought leadership, and citations.',
    items: [
      { id: 'quote-classic-serif', label: 'Classic serif quote', usesTitle: true, usesBlurb: true, image: 'assets/icon/image-templates/image-template-quote-classic-serif.jpg', defaultImagePlacement: 'attention', tags: ['pro', 'quote'] },
      { id: 'quote-profile-highlight', label: 'Profile highlight quote', usesTitle: true, usesBlurb: true, image: 'assets/icon/image-templates/image-template-quote-profile-highlight.jpg', defaultImagePlacement: 'center', tags: ['pro', 'quote'] }
    ]
  },
  {
    id: 'editorial',
    label: 'Editorial Templates',
    description: 'Magazine-style layouts for premium campaigns and features.',
    items: [
      { id: 'framed-headline-photo-top', label: 'Framed headline (photo top)', usesTitle: true, image: 'assets/icon/image-templates/image-template-framed-headline-photo-top.jpg', defaultImagePlacement: 'attention', tags: ['pro'] },
      { id: 'editorial-sidebar', label: 'Editorial sidebar', usesTitle: true, usesBlurb: true, image: 'assets/icon/image-templates/image-template-editorial-sidebar.jpg', defaultImagePlacement: 'center', tags: ['pro'] },
      { id: 'spotlight-panel', label: 'Spotlight panel', usesTitle: true, usesBlurb: true, image: 'assets/icon/image-templates/image-template-spotlight-panel.jpg', defaultImagePlacement: 'attention', tags: ['pro'] },
      { id: 'poster-frame', label: 'Poster frame', usesTitle: true, usesBlurb: true, image: 'assets/icon/image-templates/image-template-poster-frame.jpg', defaultImagePlacement: 'attention', tags: ['pro'] }
    ]
  }
];
